// @/services/content/store/modules/self-assessment-co.js
export class SelfAssessmentCOHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Self Assessment Company Overview content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.selfAssessmentCO?.[locale];
    if (localeContent) return localeContent;

    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.selfAssessmentCO?.['en'] || null;
    }

    return null;
  }
}